<template>
  <el-dialog
    :title="title"
    :visible="visible"
    :width="width + 'px'"
    :before-close="onClose"
    :close-on-click-modal="false"
  >
    <div class="containner" :style="{ height: height + 'px' }">
      <slot name="content"></slot>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="button1" type="danger" @click="onClose()" v-if="isShowCancle">取 消</el-button>
      <el-button class="button2" type="primary" @click="onConfirm()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: "标题",
      },
      visible: {
        type: Boolean,
        default: false,
      },
      width: {
        type: Number,
        default: 600,
      },
      height: {
        type: Number,
        default: 250,
      },
      isShowCancle: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      //关闭事件
      onClose() {
        this.$emit("onClose");
      },
      //确认事件
      onConfirm() {
        this.$emit("onConfirm");
      },
    },
  };
</script>

<style lang="scss" scoped>
  .containner{
    overflow-x: initial;
    overflow-y: auto;
  }
  .el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    ::v-deep .el-dialog {
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;
      .el-dialog__header {
        opacity: 1;
        background: linear-gradient(180deg, #64B5FF 0%, rgba(199, 228, 255, 0.09) 100%);
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;
        height: 55px;
        .el-dialog__title {
          font-size: 18px;
          font-weight: 600;
          line-height: 21px;
          color: #333333;
          opacity: 1;
        }
        .el-dialog__close {
          color: #fff;
        }
      }
      .el-dialog__body {
        .containner{
          .el-form{
            .el-form-item{
              margin-bottom: 30px;
              .el-form-item__label{
                font-size: 15px;
                font-weight: 400;
                color: #333333;
                opacity: 1;
              }
            }
          }
        }
      }
      .el-dialog__footer {
        .dialog-footer{
          display: flex;
          justify-content: center;
          padding: 10px;
          .button1{
            margin-right: 25px;
          }
          .button2{
            margin-left: 25px;
          }
        }
      }
    }
  }
</style>
